var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.minutesLeft < 60)?_c('span',{staticClass:"font-weight-bold"},[_vm._v("   "),(_vm.minutesLeft > 1)?_c('span',[_vm._v(" ("+_vm._s(_vm.minutesLeft)+" min)")]):_c('span',[_vm._v(" (NOW)")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }